<template lang="html">
    <list-template ref="list-template" actionUrl="advertisement/findAdvertisement.action" :queryParams="queryParams">
      <template slot="search" scope="scope">
        <el-button type="primary" style="margin-right:20px;" @click="$router.push('addAdvertisement')">发布新banner</el-button>
      </template>
      <template slot="item" scope="scope">
        <el-card class="basic-margin" v-for="data in scope.datas">
           <el-row>
            <el-col :span="3">
              <img :src="data.imgLink" style="width:150px;height:100px;">
            </el-col>

            <el-col :span="12">

              <div v-if="loginInfo.loginPath=='cxh'">已投放地区{{data.channelCount}} 个 渠道 <el-tag type="success" size="mini" style="margin-top:10px;margin-left:10px;">{{data.status | statusFilter}}</el-tag></div>

              <div style="color:#999999;margin-top:10px;">更新时间 {{data.createTime | dateTimeFormat}}</div>

            </el-col>
            <el-col :span="9" style="text-align:right;">
              <el-button type="text" @click="$router.push({name:'修改banner', params: { id: data.id }})">修改banner</el-button>
              <el-button type="text" v-confirm confirm-text="确定刷新广告" requestUrl="advertisement/refreshAdvertisement.action" :confirm-data="{id:data.id}" @onConfirm="$refs['list-template'].search()">刷新</el-button>
              <el-button type="text" v-confirm :confirm-text="data.status==0?'确定上架banner':'确定下架banner'" requestUrl="advertisement/lowerShelfAdvertisement.action" :confirm-data="{id:data.id}" @onConfirm="$refs['list-template'].search()">{{data.status==0?'上架':'下架'}}</el-button>

            </el-col>

          </el-row>
        </el-card>
      </template>
    </list-template>
</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import BasicPager from '@/mixins/BasicPager'
export default {
  name: 'advertisement',
  extends: BasicPager,
  components: {
    ListTemplate
  },
  data: function () {
    return {
      queryParams: {
        isSxb: 1
      }
    }
  },
  filters: {
    statusFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 0:
          str = '已下架'
          break
        case 1:
          str = '已上架'
          break
        default:
          str = '暂无'
      }

      return str
    }
  },
  created: function () {
    if (this.loginInfo.loginPath == 'channel') {
      this.queryParams.isSxb = 0
    } else {
      this.queryParams.isSxb = 1
    }
  }
}
</script>

<style lang="css" scoped>
</style>
